import styles from '@components/components/HeatInstallationForm/components/Failed/Failed.module.scss';
import React from 'react';
import {
  Button,
  Card,
  CardBody,
  Content,
  FontAwesomeProIcon,
  Link,
  List,
  ListItem,
} from '@wienenergiegithub/ui-next';

const Failed = ({ store, isGeneralRecommender, setStep }) => {
  const addressPickerLink = store.useValue('addressPickerLink');

  const handleBackToOverview = () => {
    // we have to remove email from the store/storage
    // so beratung does not show up in results
    // and user has to enter a new email
    store.setValue('email', '');
    // go back to the calculation results
    setStep(3);
  };

  return (
    <Card>
      <CardBody>
        <List
          align="center"
          icon={
            <FontAwesomeProIcon
              icon="times"
              role="presentation"
              type="regular"
            />
          }
          type="checkmark"
          variant="error"
        >
          <ListItem data-purpose="error-message">
            Es ist ein Fehler aufgetreten.
          </ListItem>
        </List>
        <Content>
          Uuupps! Beim Versuch Ihre Bestellung zu versenden, ist leider ein
          Fehler aufgetreten. Bitte versuchen Sie es später nochmal.
        </Content>
        <Content>
          Bei Fragen sind wir gern per E-Mail unter{' '}
          <a
            // TODO: we should fetch this email from the backend
            href="mailto:nachinstallation@wienenergie.at"
            rel="noreferrer"
            target="_blank"
          >
            nachinstallation@wienenergie.at
          </a>{' '}
          für Sie da!
        </Content>
        <div className={styles.actions}>
          {isGeneralRecommender ? (
            <Button
              className={styles.action}
              onClick={handleBackToOverview}
              variant="link"
            >
              Zurück zur Übersicht
            </Button>
          ) : (
            <Button
              render={
                <Link className={styles.action} to={addressPickerLink}>
                  Zurück zur Übersicht
                </Link>
              }
              variant="link"
            />
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default Failed;
